[
  {
    "code": "CN-34",
    "name": "Anhui"
  },
  {
    "code": "CN-11",
    "name": "Beijing"
  },
  {
    "code": "CN-50",
    "name": "Chongqing"
  },
  {
    "code": "CN-35",
    "name": "Fujian"
  },
  {
    "code": "CN-62",
    "name": "Gansu"
  },
  {
    "code": "CN-44",
    "name": "Guangdong"
  },
  {
    "code": "CN-45",
    "name": "Guangxi"
  },
  {
    "code": "CN-52",
    "name": "Guizhou"
  },
  {
    "code": "CN-46",
    "name": "Hainan"
  },
  {
    "code": "CN-13",
    "name": "Hebei"
  },
  {
    "code": "CN-23",
    "name": "Heilongjiang"
  },
  {
    "code": "CN-41",
    "name": "Henan"
  },
  {
    "code": "CN-42",
    "name": "Hubei"
  },
  {
    "code": "CN-43",
    "name": "Hunan"
  },
  {
    "code": "CN-32",
    "name": "Jiangsu"
  },
  {
    "code": "CN-36",
    "name": "Jiangxi"
  },
  {
    "code": "CN-22",
    "name": "Jilin"
  },
  {
    "code": "CN-21",
    "name": "Liaoning"
  },
  {
    "code": "CN-15",
    "name": "Nei Mongol"
  },
  {
    "code": "CN-64",
    "name": "Ningxia"
  },
  {
    "code": "CN-63",
    "name": "Qinghai"
  },
  {
    "code": "CN-61",
    "name": "Shaanxi"
  },
  {
    "code": "CN-37",
    "name": "Shandong"
  },
  {
    "code": "CN-31",
    "name": "Shanghai"
  },
  {
    "code": "CN-14",
    "name": "Shanxi"
  },
  {
    "code": "CN-51",
    "name": "Sichuan"
  },
  {
    "code": "CN-12",
    "name": "Tianjin"
  },
  {
    "code": "CN-65",
    "name": "Xinjiang"
  },
  {
    "code": "CN-54",
    "name": "Xizang"
  },
  {
    "code": "CN-53",
    "name": "Yunnan"
  },
  {
    "code": "CN-33",
    "name": "Zhejiang"
  }
]